import React from 'react'
import './Badge.scss'

interface IProps {
  children?: any,
  className?: any,
  'data-attribute'?: any,
}

const Badge = ({
  children = null,
  className = '',
  'data-attribute': dataAttribute
}: IProps) => {
  return <div className = {`badgebox ${className}`} data-attribute={dataAttribute}>{children}</div>
}

export default Badge
